const MY_UPDATES_INFO_PREFIX = 'hideMyUpdatesInfo'

class MyUpdatesTabController {
  constructor ($log, ProductService, VehicleService, $state, $scope, $rootScope, $window, MetricsService) {
    'ngInject'
    this.productService = ProductService
    this.vehicleService = VehicleService
    this.$state = $state
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.$window = $window

    this.items = []
    this.isProcessing = true

    this.$log = $log
    this.metricsService = MetricsService
    // Async loading...
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
      .then((v) => {
        if (!v) {
          return Promise.reject()
        }
        this.vehicle = v
        this.$log.debug('getProductsToUpdate')
        this.myUpdatesInfo()
        return this.productService.getProductsToUpdate(v.vin)
      })
      .then((res) => {
        this.isProcessing = false
        this.error = null
        this.items = this.items.concat(res)
        this.safeApply()
        return Promise.resolve(this.items)
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-updates.error',
          cause: err
        }
        this.safeApply()
        return Promise.reject(err)
      })
  }

  askForUpdate (item) {
    this.success = null
    this.isProcessing = true
    const ref = item ? item.ref : null
    return this.productService.updateProducts(this.vehicle.vin, ref)
      .then((res) => {
        this.error = null
        this.isProcessing = false
        return this.$state.go('installation', {success: 'my-updates.update_success'})
      }, (err) => {
        this.isProcessing = false
        this.error = {
          message: 'my-updates.update_error',
          cause: err
        }
        return Promise.reject(err)
      })
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }

  myUpdatesInfo () {
    const huType = this.vehicle.huType
    if (huType === 'MM12') {
      this.info = {
        cookieKey: MY_UPDATES_INFO_PREFIX + '.mm12',
        message: 'my-updates.my_updates_info_mm12'
      }
    } else if (huType === 'RADNAV') {
      this.info = {
        cookieKey: MY_UPDATES_INFO_PREFIX + '.radnav',
        message: 'my-updates.my_updates_info_radnav'
      }
    }
  }
}

export default MyUpdatesTabController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-updates-tab/my-updates-tab.controller.js